const config = {
  state: {
    appConfig: {}
  },
  getters: {
    organizeToolboxLinks: state => (state.appConfig !== {} ? state.appConfig.OrganizeToolboxLinks : []),
    participateToolboxLinks: state => (state.appConfig !== {} ? state.appConfig.ParticipateToolboxLinks : []),
    walktroughToolboxLinks: state => (state.appConfig !== {} ? state.appConfig.WalktroughToolboxLinks : []),
    subscribeDescription: state => (state.appConfig !== {} ? state.appConfig.SubscribeDescription : ''),
    subscribePrice: state => (state.appConfig !== {} ? state.appConfig.SubscribePrice : 0),
    subscribeImage: state => (state.appConfig !== {} ? state.appConfig.SubscribeImage : ''),
    businessProductValidationUrl: state => (state.appConfig !== {} ? state.appConfig.BusinessProductValidationUrl : ''),
    badges: state => (state.appConfig !== {} ? state.appConfig.Badges : '')
  },
  mutations: {
    setConfig: (state, config) => (state.appConfig = config)
  }
}

export default config
